export const SiteHtmlPageTitle = "Blues Developers";
